export const getAddNewResumeObj = () => {
  return {
    id: 0,
    firstName: "",
    middleName: "",
    lastName: "",
    education: "",
    experience: "",
    contact: "",
    remarks: "",
    cv: null,
  };
};
